export default {
  setUser(state, payload) {
    state.token = payload.token;
    state.email = payload.email;
    state.fname = payload.fname;
    state.lname = payload.lname;
    state.name = payload.fname + ' ' + payload.lname;
    state.school = payload.school;
    state.isLoggedIn = payload.token !== null && payload.token != '' ? true : false;
    state.access_type = payload.access_type;
    state.notifications = payload.notifications;
  },
  setExperience(state, payload) {
    state.experience = payload;
  },
  setExperiencePostwork(state, payload) {
    const experience = Object.assign({}, state.experience);
    experience.postwork = payload;
    state.experience = experience;
  },
  setAccessType(state, payload) {
    state.access_type = payload;
  },
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  addNotification(state, payload) {
    state.notifications.unshift(payload);
  },
  markNotificationsRead(state, numNotifications) {
    const notifications = Array.from(state.notifications);
    let numMarked = 0;
    notifications.forEach((notification) => {
      if (notification.is_read == 0 && numMarked < numNotifications) {
        notification.is_read = 1;
        numMarked++;
      }
    });
    state.notifications = notifications;
  },
  markNotificationRead(state, nID) {
    const notifications = Array.from(state.notifications);
    notifications.forEach((notification) => {
      if (notification.id == nID) {
        notification.is_read = 1;
      }
    });
    state.notifications = notifications;
  },
  deleteNotification(state, nID) {
    const notifications = Array.from(state.notifications);
    const notifications_new = [];
    notifications.forEach((notification) => {
      if (notification.id != nID) {
        notifications_new.push(notification);
      }
    });
    state.notifications = notifications_new;
  },
  deleteNotifications(state) {
    state.notifications = [];
  },
};
